import { TokenServiceClient } from '@johnlewispartnership/wtr-website-authentication/dist/service';

import config from 'config';
import { withApiBaseUrl } from 'services/with-api-base-url';

const url = withApiBaseUrl(config.services.tokenClient.path);

const tokenServiceClient = new TokenServiceClient(url);

export default tokenServiceClient;
